import { getFileDataUri } from 'utils/file';

const generateImageUri = (base64String) => (base64String ? getFileDataUri(base64String) : null);

export const useSetAddImages = (images, dataActaSelected, typeOption) => {
  if (typeOption === 'edit') {
    // eslint-disable-next-line array-callback-return
    dataActaSelected.fiscalizacion.map((x) => {
      // eslint-disable-next-line array-callback-return
      images.fiscalizacion.map((f) => {
        if (x.idFirmante === f.idFirmante) {
          // eslint-disable-next-line no-param-reassign
          x.firma = {
            fileList: [
              {
                uid: 1,
                status: 'done',
                name: 'imgFirma.png',
                url: generateImageUri(f.firma),
                thumbUrl: generateImageUri(f.firma)
              }
            ]
          };
          // eslint-disable-next-line no-param-reassign
          x.identAnverso = {
            fileList: [
              {
                uid: 2,
                status: 'done',
                name: 'imgFirma.png',
                url: generateImageUri(f.identAnverso),
                thumbUrl: generateImageUri(f.identAnverso)
              }
            ]
          };
          // eslint-disable-next-line no-param-reassign
          x.identReverso = {
            fileList: [
              {
                uid: 3,
                status: 'done',
                name: 'imgFirma.png',
                url: generateImageUri(f.identReverso),
                thumbUrl: generateImageUri(f.identReverso)
              }
            ]
          };
        }
      });
    });
    // eslint-disable-next-line array-callback-return
    dataActaSelected.juntaLocalDistrital.map((y) => {
      // eslint-disable-next-line array-callback-return
      images.juntaLocalDistrital.map((f) => {
        // eslint-disable-next-line eqeqeq
        if (y.idFirmante == f.idFirmante) {
          // eslint-disable-next-line no-param-reassign
          y.firma = {
            fileList: [
              {
                uid: 1,
                status: 'done',
                name: 'imgFirma.png',
                url: generateImageUri(f.firma),
                thumbUrl: generateImageUri(f.firma)
              }
            ]
          };
          // eslint-disable-next-line no-param-reassign
          y.identAnverso = {
            fileList: [
              {
                uid: 2,
                status: 'done',
                name: 'imgFirma.png',
                url: generateImageUri(f.identAnverso),
                thumbUrl: generateImageUri(f.identAnverso)
              }
            ]
          };
          // eslint-disable-next-line no-param-reassign
          y.identReverso = {
            fileList: [
              {
                uid: 3,
                status: 'done',
                name: 'imgFirma.png',
                url: generateImageUri(f.identReverso),
                thumbUrl: generateImageUri(f.identReverso)
              }
            ]
          };
        }
      });
    });
    // eslint-disable-next-line array-callback-return
    dataActaSelected.sujetosObligados.map((z) => {
      // eslint-disable-next-line array-callback-return
      images.sujetosObligados.map((f) => {
        // eslint-disable-next-line eqeqeq
        if (z.idFirmante == f.idFirmante) {
          // eslint-disable-next-line no-param-reassign
          z.firma = {
            fileList: [
              {
                uid: 1,
                status: 'done',
                name: 'imgFirma.png',
                url: generateImageUri(f.firma),
                thumbUrl: generateImageUri(f.firma)
              }
            ]
          };
          // eslint-disable-next-line no-param-reassign
          z.identAnverso = {
            fileList: [
              {
                uid: 2,
                status: 'done',
                name: 'imgFirma.png',
                url: generateImageUri(f.identAnverso),
                thumbUrl: generateImageUri(f.identAnverso)
              }
            ]
          };
          // eslint-disable-next-line no-param-reassign
          z.identReverso = {
            fileList: [
              {
                uid: 3,
                status: 'done',
                name: 'imgFirma.png',
                url: f.identReverso,
                thumbUrl: generateImageUri(f.identReverso)
              }
            ]
          };
        }
      });
    });
    return dataActaSelected;
  }

  // eslint-disable-next-line array-callback-return
  dataActaSelected.fiscalizacion.map((x) => {
    // eslint-disable-next-line array-callback-return
    images.fiscalizacion.map((f) => {
      if (x.idFirmante === f.idFirmante) {
        // eslint-disable-next-line no-param-reassign
        x.firma = f.firma;
        // eslint-disable-next-line no-param-reassign
        x.identAnverso = f.identAnverso;
        // eslint-disable-next-line no-param-reassign
        x.identReverso = f.identReverso;
      }
    });
  });
  // eslint-disable-next-line array-callback-return
  dataActaSelected.juntaLocalDistrital.map((y) => {
    // eslint-disable-next-line array-callback-return
    images.juntaLocalDistrital.map((f) => {
      // eslint-disable-next-line eqeqeq
      if (y.idFirmante == f.idFirmante) {
        // eslint-disable-next-line no-param-reassign
        y.firma = f.firma;
        // eslint-disable-next-line no-param-reassign
        y.identAnverso = f.identAnverso;
        // eslint-disable-next-line no-param-reassign
        y.identReverso = f.identReverso;
      }
    });
  });
  // eslint-disable-next-line array-callback-return
  dataActaSelected.sujetosObligados.map((z) => {
    // eslint-disable-next-line array-callback-return
    images.sujetosObligados.map((f) => {
      // eslint-disable-next-line eqeqeq
      if (z.idFirmante == f.idFirmante) {
        // eslint-disable-next-line no-param-reassign
        z.firma = f.firma;
        // eslint-disable-next-line no-param-reassign
        z.identAnverso = f.identAnverso;
        // eslint-disable-next-line no-param-reassign
        z.identReverso = f.identReverso;
      }
    });
  });
  return dataActaSelected;
};
